import { useEffect, useRef, useState } from 'react';
import { ChevronArrowDown } from '../../../assets/icons';
import React from 'react';
import { useAppSelector } from '../../../store/hooks/StoreHooks';
import ButtonGroup from '../../common/button-group';
import useProjectHeaderFacade from '../../../facade/calculation/calculation-input/projectHeader.facade';
import { useParams } from 'react-router-dom';
import { ProjectStatus } from '../../../utilities/AppConstants';
import Loader from '../../common/loader';
import useProjectFacade from '../../../facade/project.Facade';
import { showToast } from '../../../utilities/commonUtilities';

export interface AcknowledgeDropdownProps {
    onSelect?: (id: string) => void;
    dropdownActive?: boolean;
    setDropdownActive?: any;
}
const AcknowledgeDropdown: React.FC<AcknowledgeDropdownProps> = ({ dropdownActive, setDropdownActive }) => {
    const { sharedCases } = useAppSelector((state) => state?.myProjects);
    const { ID } = useParams();
    const parentProjectID = ID?.split("projectID=")?.[1];
    const [selectedCase, setSelectedCase] = useState('');
    const [selectedCaseName, setSelectedCaseName] = useState('');
    const dropdownRef = useRef<HTMLDivElement>(null);
    const { projectAndAffiliations } = useAppSelector(
        (state) => state?.projectHeader
    );
    const { getProjectAndAffiliationsDetails } = useProjectHeaderFacade();
    const { triggerUpdateProjectStatus } = useProjectFacade();
    const [loading, setLoading] = useState<boolean>(false);
    const { user, customerEnabled } = useAppSelector((state) => state.auth);
    const { projectReadOnly } = useAppSelector((state) => state.projectHeader);
    const [isOpen, setIsOpen] = useState(false);

    const options = customerEnabled ? projectAndAffiliations
        ?.filter((x: any) => {
            return (
                (sharedCases?.length > 0 && sharedCases[0]?.case?.includes(x.projectID)) ||
                x.created_By === user?.userID
            );
        })
        ?.map((x: any, index: number) => {
            return {
                id: x.projectID,
                name: `${x?.displayCaseName}: ${x.caseName}`,
            };
        }) : projectAndAffiliations ?.map((x: any, index: number) => {
            return {
                id: x.projectID,
                name: `${x?.displayCaseName}: ${x.caseName}`,
            };
        });


    const onOptionSelected = (item: { id: string, name: string }) => {
        setSelectedCase(item.id);
        setSelectedCaseName(item.name);
        setIsOpen(false);
    }

    const acknowledgeBtnOptions = [
        { id: 1, icon: "", label: "Acknowledge cases", type: "primary", className: "px-[18px] py-3 font-bold text-base" }
    ];
    const confirmBtnOptions = [
        { id: 1, icon: "", label: "Confirm", type: "secondary", className: "px-[18px] py-0 font-bold text-base w-full" }
    ];
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setDropdownActive(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const onConfirm = async () => {
        setLoading(true);
        setDropdownActive((prev: any) => !prev);
        const statusChangeResponse = await triggerUpdateProjectStatus({ id: selectedCase, status: ProjectStatus.acknowldged, updateTree: false });
        if (statusChangeResponse.payload === 'Success') {
            showToast('The cases have been successfully acknowledged');
            await getProjectAndAffiliationsDetails(parentProjectID ?? '');
        } else {
            showToast('An error occurred while acknowledging cases.', 'error');
        }

        setLoading(false);
        setDropdownActive(false);
    }
    const shouldShowAcknowledgeButton = () => {
        setDropdownActive(true);
    };
    const toggleDropdown = (event: React.MouseEvent) => {
        event.preventDefault();
        event.stopPropagation();
        setIsOpen(!isOpen);
    };

    return (
        <div className="flex flex-col items-center" ref={dropdownRef}>
            <Loader isLoading={loading} />
            <div className="relative inline-block text-left">
                {
                    customerEnabled && !projectAndAffiliations?.find((x: any) => x.status === ProjectStatus.acknowldged) &&
                    <ButtonGroup
                        buttonOptions={acknowledgeBtnOptions}
                        handleClick={shouldShowAcknowledgeButton}
                    />
                }
                {
                    dropdownActive && options?.length > 0 &&
                    <div className="w-80 p-4 absolute right-0 top-[60px] z-10 mt-2 origin-top-right rounded-md  bg-darkcolor-700 border-[1px] border-darkcolor-400 text-sm font-normal border-solid shadow-lg ring-1 ring-black/5 transition focus:outline-hidden data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-enter:duration-100 data-enter:ease-out data-leave:duration-75 data-leave:ease-in text-neutral-25">
                        <div className="flex flex-col w-full">
                            <div
                                className="relative flex flex-col gap-[6px] w-full rounded-[8px] bg-darkcolor-700"
                            >
                                <label className="flex flex-row justify-start items-start text-neutral-25">
                                    Select the cases you would like to acknowledge
                                </label>
                                <div className="relative border-darkcolor-400 border-[1px] rounded-[8px]">
                                    <button
                                        type="button"
                                        onClick={toggleDropdown}
                                        className="flex justify-between items-center gap-[8px] w-full py-2 px-4 rounded-[8px] text-neutral-25 focus:outline-none whitespace-nowrap overflow-hidden text-ellipsis"
                                    >
                                        <span className="overflow-hidden text-ellipsis">{selectedCaseName || "Select"}</span>
                                        <ChevronArrowDown size={15} className="relative bottom-[3px] cursor-pointer" />
                                    </button>
                                    <ul
                                        className="absolute z-[1000] mt-0.5 w-full border border-darkcolor-400 rounded-md shadow-lg overflow-auto hover:rounded-t-[8px] bg-darkcolor-800"
                                    >
                                        {isOpen && options.map((option: any) => (
                                            <li
                                                key={option.id}
                                                onClick={() => onOptionSelected(option)}
                                                className="cursor-pointer py-2 px-4 hover:bg-darkcolor-600 break-word text-neutral-25"
                                            >
                                                {option.name}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>

                            <ButtonGroup
                                disabled={!selectedCase}
                                className={`w-full mt-4 ${!selectedCase ? 'opacity-50' : ''}`}
                                buttonOptions={confirmBtnOptions}
                                handleClick={onConfirm}
                            />
                        </div>
                    </div>
                }
            </div>
        </div >
    )
}

export default AcknowledgeDropdown;
